export default __webpack_public_path__ + "static/media/pexels-jan-caluwé-15917391.8ac76c26.jpg";